<template>
  <div class="d-inline-flex my-6">
    <v-card
      :color="$vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-4'"
      class="py-4 px-8 rounded-xl"
      flat
    >
      <v-card-text>
        <div class="d-inline-flex">
          <div class="text-start">
            <div class="text-center">
              <slot name="cardIcon">
                <v-icon
                  v-if="itemIcon"
                  :color="itemIconColor"
                  class="mb-4"
                  size="128"
                >
                  {{ itemIcon }}
                </v-icon>
              </slot>

              <slot name="cardTitle">
                <div
                  v-if="itemTitle"
                  :class="itemSubTitle ? 'mb-3' : 'mb-6'"
                  class="text-h5 font-weight-bold"
                >
                  {{ itemTitle }}
                </div>
              </slot>

              <slot name="cardSubTitle">
                <div
                  v-if="itemSubTitle"
                  class="body-1 font-weight-light mb-6"
                >
                  {{ itemSubTitle }}
                </div>
              </slot>
            </div>


            <slot name="cardBullets">
              <template v-for="(bullet, index) in itemBullets">
                <div
                  :key="`nodata-bullet-${index}`"
                  class="body-2 mb-3 d-flex align-start align-sm-center"
                >
                  <v-icon
                    v-if="itemBulletIcon"
                    :color="itemBulletIconColor"
                    class="mr-2"
                  >
                    {{ itemBulletIcon }}
                  </v-icon>

                  {{ bullet }}
                </div>
              </template>
            </slot>
          </div>
        </div>
      </v-card-text>

      <slot name="cardActions">
        <v-card-actions
          v-if="itemButton"
          class="px-4 pb-4 justify-center"
        >
          <slot name="cardActionsButtons">
            <v-btn
              :block="itemButtonBlock"
              :color="itemButtonColor"
              class="pr-3"
              dark
              depressed
              large
              @click="isFunction(itemButtonCallback) && itemButtonCallback()"
            >
              <v-icon left>
                {{ itemButtonIcon }}
              </v-icon>

              {{ itemButton }}
            </v-btn>
          </slot>
        </v-card-actions>

        <slot name="cardActionsAppend" />
      </slot>
    </v-card>
  </div>
</template>

<script>

import {isFunction} from '@/lib/data/Validations/utils/Utils.js'

export default {
  name      : 'VDataTableNoData',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    title: {
      type   : String,
      default: ''
    },
    subtitle: {
      type   : String,
      default: ''
    },
    icon: {
      type   : String,
      default: ''
    },
    iconColor: {
      type   : String,
      default: ''
    },
    bullets: {
      type   : Array,
      default: undefined
    },
    bulletIcon: {
      type   : String,
      default: ''
    },
    bulletIconColor: {
      type   : String,
      default: ''
    },
    buttonTitle: {
      type   : String,
      default: ''
    },
    buttonIcon: {
      type   : String,
      default: ''
    },
    buttonColor: {
      type   : String,
      default: ''
    },
    buttonBlock: {
      type   : Boolean,
      default: undefined
    },
    buttonCallback: {
      type   : Function,
      default: undefined
    },
    noDataObj: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {}
  },
  computed: {
    itemIcon() {
      return this.icon || this.noDataObj?.Icon || ''
    },

    itemIconColor() {
      return this.iconColor || this.noDataObj?.IconColor || ''
    },

    itemTitle() {
      return this.title || this.noDataObj?.Title || ''
    },

    itemSubTitle() {
      return this.subtitle || this.noDataObj?.Subtitle || ''
    },

    itemBullets() {
      return this.bullets || this.noDataObj?.Bullets?.Items || []
    },

    itemBulletIcon() {
      return this.bulletIcon || this.noDataObj?.Bullets?.Icon || ''
    },

    itemBulletIconColor() {
      return this.bulletIconColor || this.noDataObj?.Bullets?.IconColor || ''
    },

    itemButton() {
      return this.buttonTitle || this.noDataObj?.Button?.Title || ''
    },

    itemButtonIcon() {
      return this.buttonIcon || this.noDataObj?.Button?.Icon || ''
    },

    itemButtonColor() {
      return this.buttonColor || this.noDataObj?.Button?.Color || ''
    },

    itemButtonBlock() {
      return this.buttonBlock || this.noDataObj?.Button?.Block || false
    },

    itemButtonCallback() {
      return this.buttonCallback
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {isFunction}
}
</script>

<style scoped>

</style>
